"use client";

import React from "react";

import DoctorBannerDesktop from "@/components/newPageComponent/mbbs/DoctorBannerDesktop";
import dynamic from "next/dynamic";
import GlobalFooter from "@/components/common/newCommonComponent/GlobalFooter";
import GlobalHeaderNew from "@/components/common/newCommonComponent/GlobalHeaderNew";

const DoctorFAQs = dynamic(
  () => import("@/components/newPageComponent/mbbs/DoctorFAQs"),
  {
    ssr: false,
  },
);

const DoctorContactUsDesktop = dynamic(
  () => import("@/components/newPageComponent/mbbs/DoctorContactUsDesktop"),
  {
    ssr: false,
  },
);

const DoctorUSPathwayDesktop = dynamic(
  () => import("@/components/newPageComponent/mbbs/DoctorUSPathwayDesktop"),
  {
    ssr: false,
  },
);

const DoctorMedicalCareerDesktop = dynamic(
  () => import("@/components/newPageComponent/mbbs/DoctorMedicalCareerDesktop"),
  {
    ssr: false,
  },
);

const DoctorUSTimelineDesktop = dynamic(
  () => import("@/components/newPageComponent/mbbs/DoctorUSTimelineDesktop"),
  { ssr: false },
);

const DoctorHowUSPathwayDesktop = dynamic(
  () => import("@/components/newPageComponent/mbbs/DoctorHowUSPathwayDesktop"),
  { ssr: false },
);

const DoctorResidencyUSADesktop = dynamic(
  () => import("@/components/newPageComponent/mbbs/DoctorResidencyUSADesktop"),
  { ssr: false },
);

const DoctorClinicalUSADesktop = dynamic(
  () => import("@/components/newPageComponent/mbbs/DoctorClinicalUSADesktop"),
  { ssr: false },
);

const DoctorQuickConnectDesktop = dynamic(
  () => import("@/components/newPageComponent/mbbs/DoctorQuickConnectDesktop"),
  { ssr: false },
);

const DoctorAmericaStudyDesktop = dynamic(
  () => import("@/components/newPageComponent/mbbs/DoctorAmericaStudyDesktop"),
  { ssr: false },
);

// const DoctorMbbsMdAmericaDesktop = dynamic(
//   () => import("@/components/newPageComponent/mbbs/DoctorMbbsMdAmericaDesktop"),
//   { ssr: false },
// );

const DesktopPage: React.FC = () => {
  return (
    <main className="bg-white min-h-screen">
      <GlobalHeaderNew />
      <DoctorBannerDesktop />
      <div id="acc" className="w-full">
        <DoctorUSPathwayDesktop />
      </div>
      <DoctorMedicalCareerDesktop />
      <DoctorUSTimelineDesktop />
      <DoctorHowUSPathwayDesktop />
      <DoctorAmericaStudyDesktop />
      <DoctorClinicalUSADesktop />
      <DoctorResidencyUSADesktop />
      {/* <DoctorMbbsMdAmericaDesktop /> */}
      <DoctorContactUsDesktop />
      <div className="bg-[#061A2F]">
        <DoctorFAQs />
      </div>
      <div className="w-full">
        <GlobalFooter />
      </div>
      <DoctorQuickConnectDesktop />
    </main>
  );
};

export default DesktopPage;
